export default "__VITE_ASSET__lKRqajd1__"